<template>
  <div class="">
    <v-col class="pa-0 ma-0 text-right">
      <v-spacer></v-spacer>
      <v-btn
          color="success"
          class="mb-0 ml-3 px-0 white--text"
          elevation="0"
          min-width="36"
          min-height="36"
          @click="$refs['uploadFiles'].click()"
          :disabled="isFilesLoading"
          :loading="isFilesLoading"
          :title="$t('common.add_document')"
      >
        <v-icon small>mdi-attachment</v-icon>
      </v-btn>
      <input
          :key="componentKey"
          v-show="false"
          ref="uploadFiles"
          type="file"
          multiple
          @change="uploadFiles"
          accept="image/gif,image/jpeg,image/png,application/pdf"
      />
    </v-col>
    <v-data-table
      :loading="isFilesLoading"
      :headers="customerDocumentsHeader"
      :items="customerDocuments"
      class="elevation-0 mb-3 tableCalculations"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item.created_at="props">
        {{ props.item.created_at | moment("DD.MM.YYYY") }}
        <br/>
        {{ props.item.created_at | moment("HH:mm") }}
      </template>
      <template v-slot:item.link="props">
        <v-btn
            fab
            small
            text
            :href="backendURL+props.item.path + props.item.file"
            target="_blank"
            :disabled="!fetched"
        ><v-icon small>fa-link</v-icon></v-btn
        >
      </template>
      <template v-slot:item.actions="props">
        <div class="text-right" style="min-width: 280px">
          <span class="btn-td-wrap">
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              @click="remove(props.item)"
              color="red lighten-2"
              class="mb-0 ml-3 px-0 white--text"
              :disabled="!fetched"
              :loading="!fetched"
              :title="$t('common.remove')"
            >
              <v-icon small>$trash</v-icon>
            </v-btn>
          </span>
        </div>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:loading>
        {{ $t("common.loading") }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";

export default {
  name: "customerDocumentsTable",
  mixins: [CommonMixin],
  props: {
    customerId: null,
  },
  data: () => ({
    componentKey: 0
  }),
  mounted() {
    if(this.customerId) {
      this.$store.dispatch("customers/getCustomerDocuments", this.customerId)
    }
  },
  updated() {},
  computed: {
    ...mapFields("customers", [
      "customer",
      "fetched",
      "isFilesLoading",
      "customerFormTabsId",
      "customerDocuments"
    ]),
    documents() {
      return [];
    },
    customerDocumentsHeader() {
      return [
        {
          text: this.$t("common.title"),
          value: "original_file_name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.link"),
          value: "link",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.created_by"),
          value: "user.name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: "",
          value: "actions",
          sortable: true,
          class: "text-no-wrap",
        },
      ];
    },
  },
  watch: {
    customerId(id){
      if(id) {
        this.$store.dispatch("customers/getCustomerDocuments", id)
      }
    }
  },
  methods: {
    remove(document) {
      this.$store.dispatch('customers/removeCustomerDocument', {
        customer_id:this.customerId,
        document_id:document.id
      })
    },
    uploadFiles() {
      this.$store
          .dispatch("customers/uploadDocuments", {
            files: this.$refs["uploadFiles"].files,
            customer_id: this.customerId,
          })
          .then((response) => {
            if (response.data && response.data.status === "success") {
              this.$inform(this.$t("common.operation_success"));
            }
          })
          .finally(() => {
            this.componentKey++;
            this.$store.dispatch("customers/getCustomerDocuments", this.customerId)
          });
    },
  },
};
</script>
